import { useAction, useAtom } from '@reatom/npm-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { CurrencySelectorDrawer } from '@root/widgets/currency-selector'

import { TransferCardCurrencyButton } from './transfer-card-currency-button'
import { TransferWalletInfo } from './transfer-wallet-info'

import type { TransferFlowReatom } from '../../../atoms/transfer-flow'
import type { WalletModel } from '@root/entities/wallet/atoms'

type TransferCardProps = {
  wallet: WalletModel
  model: TransferFlowReatom
}

export const TransferCardTop: React.FC<TransferCardProps> = ({
  wallet,
  model,
}) => {
  const { t } = useTranslation()
  const [currencyDrawerOpen, setCurrencyDrawerOpen] = useState(false)
  const [currency] = useAtom(model.currency.currencyAtom)
  const [balance] = useAtom(model.amount.balanceAtom)

  const setCurrency = useAction(model.currency.setCurrencyAction)

  return (
    <Root>
      <TransferWalletInfo
        balance={balance}
        currency={currency}
        wallet={wallet}
      />
      <TransferCardCurrencyButton
        currency={currency}
        onClick={() => {
          setCurrencyDrawerOpen(true)
        }}
      />

      <CurrencySelectorDrawer
        wallet={wallet}
        title={t('currency.select-currency')}
        open={currencyDrawerOpen}
        onOpenChange={setCurrencyDrawerOpen}
        onCurrencySelect={(currency) => {
          setCurrency(currency)
          setCurrencyDrawerOpen(false)
        }}
        sets={['wallet']}
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;

  padding-bottom: 14px;
  padding-inline: 16px;
  padding-block: 16px 12px;
`
